import Cookies from 'js-cookie'
const initStae={
  changeOneStepDate: {},
  oneStepData:{},
  towStepDate:[],
  threeStepDate:{},
  fourStepData:[]
}
const course = {
  state: Object.assign(initStae),
  mutations: {
    CHANGE_ONE_STEP: (state, data) => {
      state.changeOneStepDate = data
    },
    SAVE_ONE_STEP_DATA:(state,data)=>{
      state.oneStepData=data.data
    },
    SET_TWO_STEP_DATE:(state,data)=>{
      state.towStepDate=data.data
    },
    SET_THREE_STEP_DATE:(state,data)=>{
      state.threeStepDate=data.data
    },
    SET_FOUR_STEP_DATA:(state,data)=>{
      state.fourStepData=data.data
    },
    INIT_SATE_DATA:(state)=>{
      // console.log("statestate",state,initStae);
      state.changeOneStepDate={}
      state.oneStepData={}
      state.towStepDate={}
      state.threeStepDate={}
      state.fourStepData=[]
    }
  },
  actions: {
    changeOneStepDate({ commit }, { data }) {
      commit('CHANGE_ONE_STEP', { data })
    },
    saveOneStepData({ commit }, { data }){
      // console.log('store', data)
      commit('SAVE_ONE_STEP_DATA', { data })
    },
    setTwoStepDate({ commit }, { data }){
      commit('SET_TWO_STEP_DATE', { data })
    },
    setThreeStepData({ commit }, { data }){
      commit('SET_THREE_STEP_DATE', { data })
    },
    setFourStepData({ commit }, { data }){
      commit('SET_FOUR_STEP_DATA', { data })
    },
    initStae({ commit }){
      commit('INIT_SATE_DATA')
    }
  }
}

export default course
